import { useUpdateAiAgentMainSetting } from '@/context/services/ai_agents_setting';

import { useTranslation } from '@/i18n';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useCallback, useState } from 'react';

type UseOfficeSettingActionsProps = {
  onClose: () => void;
};

export const useOfficeSettingActions = ({
  onClose,
}: UseOfficeSettingActionsProps) => {
  const { mutateAsync: updateSetting } = useUpdateAiAgentMainSetting();
  const { t } = useTranslation();
  const notify = useToastAPI();
  const [isEnablePending, setIsEnablePending] = useState(false);
  const [isDisablePending, setIsDisablePending] = useState(false);

  const handleConfirmEnable = useCallback(async () => {
    try {
      setIsEnablePending(true);
      const result = await updateSetting(true);
      if (result.status === 'success') {
        notify.success({
          title: t('ai_agents_setting_main_setting_use_start_success'),
          duration: 5,
        });
        onClose();
        return;
      }
      notify.error({
        title: t('ai_agents_setting_main_setting_use_start_error'),
        duration: 5,
      });
    } catch (error) {
      notify.error({
        title: t('system_error'),
        duration: 5,
      });
    } finally {
      setIsEnablePending(false);
    }
  }, [updateSetting, notify, onClose, t]);

  const handleConfirmDisable = useCallback(async () => {
    try {
      setIsDisablePending(true);
      const result = await updateSetting(false);
      if (result.status === 'success') {
        notify.success({
          title: t('ai_agents_setting_main_setting_use_stop_success'),
          duration: 5,
        });
        onClose();
        return;
      }
      notify.error({
        title: t('ai_agents_setting_main_setting_use_stop_error'),
        duration: 5,
      });
    } catch (error) {
      notify.error({
        title: t('system_error'),
        duration: 5,
      });
    } finally {
      setIsDisablePending(false);
    }
  }, [updateSetting, notify, onClose, t]);

  return {
    handleConfirmEnable,
    handleConfirmDisable,
    isEnablePending,
    isDisablePending,
  };
};
